export default __webpack_public_path__ + "static/media/logo-mini.47a5cac0.svg";